/* NOTE: API 'settings' response now contains 'menu'. Need to adopt the required changes.  */

export default {
	root: { path: '/', name: 'Home' },
	home: { path: '/home', name: 'Home' },
	pre_auth_card: { path: '/pre-auth', name: 'Pre Auth Card' },
	// Auction items
	auction_ct: { path: '/auction/categories', name: 'Auction Categories' },
	auction: { path: '/auction', name: 'Auction Items' },
	auction_item: { path: '/auction/items/:id', name: 'Auction Item' },
	complete_bid: { path: '/auction/complete-bid', name: 'Complete Bid' },
	auction_checkout: { path: '/auction/checkout', name: 'Auction Payment' },
	auction_guest_checkout: { path: '/auction/guest/checkout', name: 'Guest Auction Payment' },
	// Tickets
	tickets: { path: '/tickets', name: 'Tickets' },
	ticket_rsvp: { path: '/ticket-rsvp', name: 'Ticket RSVP' },
	ticket_checkout: { path: '/ticket/checkout', name: 'Ticket Payment' },
	ticket_guest_checkout: { path: '/ticket/guest/checkout', name: 'Guest Ticket Payment' },
	ticket_checkout_agendas: { path: '/ticket/checkout/agendas', name: 'Ticket Agendas Select' },
	ticket_guest_checkout_agendas: {
		path: '/ticket/guest/checkout/agendas',
		name: 'Ticket Agendas Select',
	},
	// Live Auction Items
	live_auction: { path: '/list-live-lots', name: 'Live Auction Items' },
	// Buy Now Items
	buy_now_items: { path: '/list-buynow-lots', name: 'Buy Now Items' },
	// Silent Auction Items
	silent_auction: { path: '/list-silent-lots', name: 'Silent Auction Items' },
	// Sealed Auction Items
	sealed_auction: { path: '/list-sealed-lots', name: 'Sealed Auction Items' },
	// Raffle || Prize Draw
	raffle: { path: '/prize-draw', name: 'Prize draw' },
	raffle_item: { path: '/prize-draw/:id', name: 'Prize Draw Item' },
	raffle_checkout: { path: '/prize-draw/checkout', name: 'Prize Draw Payment' },
	raffle_guest_checkout: { path: '/prize-draw/guest/checkout', name: 'Guest Prize Draw Payment' },
	// Pledge
	pledge: { path: '/pledge', name: 'Pledge' },
	donate: { path: '/pledge', name: 'Donate' },
	pledge_view: { path: '/pledge/:id', name: 'Pledge Item' },
	donate_charity: { path: '/pledge/charity-name', name: 'Donate to Charity Name' },
	donate_checkout: { path: '/pledge/checkout', name: 'Complete your donation' },
	donate_guest_checkout: { path: '/pledge/guest/checkout', name: 'Complete your donation' },
	// Individual Giving
	fundraising: { path: '/individual-giving', name: 'Individual Giving' },
	fundraising_team: { path: '/individual-giving/team/:id', name: 'Fundraiser Team' },
	fundraiser: { path: '/individual-giving/:id', name: 'Fundraiser' },
	fundraiser_leave_message: { path: '/individual-giving/leave-message', name: 'Leave a message' },
	fundraiser_donate_complete: {
		path: '/individual-giving/checkout',
		name: 'Complete your donation',
	},
	fundraiser_donate_guest_complete: {
		path: '/individual-giving/guest/checkout',
		name: 'Complete your donation',
	},
	// Surveys
	surveys: { path: '/survey', name: 'Surveys' },
	survey_view: { path: '/survey/:id', name: 'Survey' },
	survey_view_public: { path: '/survey/survey-public/:id', name: 'Survey' },
	survey_success: { path: '/survey/survey-success', name: 'Thank you!' },
	// Polls
	polls: { path: '/poll', name: 'Polls' },
	poll_view: { path: '/poll/:id', name: 'Polls' },
	poll_view_public: { path: '/poll/poll-public/:id', name: 'Poll' },
	poll_success: { path: '/poll/poll-success', name: 'Thank you!' },
	//Donate an item
	donate_lot: { path: '/donate-lot', name: 'Donate an item' },
	donate_lot_success: { path: '/donate-lot/success', name: 'Thank you!' },
	// Leaderboard
	leaderboard: { path: '/leaderboard', name: 'Leaderboard' },
	// Your account
	admin_dash: { path: '/admin-dash', name: 'Admin Dash' },
	redeem_voucher: { path: '/account/vouchers/redeem', name: 'Redeem Voucher' },
	confirm_ticket: { path: '/account/tickets/confirm', name: 'Confirm Ticket' },
	your_account: { path: '/account/*', name: 'Account' },
	// Terms and Privacy Policy [Here path will be the API url suffix | It will catch by the generic page route]
	terms_default: { path: '/terms', name: 'Terms' },
	privacy_default: { path: '/privacy', name: 'Privacy Policy' },
	// Payment
	payment_complete: { path: '/order-complete', name: 'Order Complete' },
	dyn_payment: { path: '/account/payment', name: 'Payment' },
	// Generic page based on route
	generic_page: { path: '/:routeKey', name: 'Page' },
	// Others
	login: { path: '/sign-in', name: 'Sign in' },
	register: { path: '/sign-up', name: 'Sign up' },
	signup_complete: { path: '/sign-up-complete', name: 'Sign up complete' },
	pr: { path: '/password-reset', name: 'Password Reset' }, // Send Link
	rp: { path: '/reset-password', name: 'Password Reset' }, // Actual Reset
	resend_pin: { path: '/resend-pin', name: 'Resend Pin' },
	nomatch: { path: '/404', name: 'Default Microsite' },
	profile: { path: '/profile', name: 'Profile' },
	agendas: { path: '/agendas', name: 'Agendas' },
}
